import * as React from "react";
import * as classNames from "classNames";
import { BaseFormElement, IBaseFormElementProps } from "./BaseFormElement";
import AriaTooltip from "../../applications/Shared/Tooltip/AriaTooltip";
import { Guid } from "../Utils/Guid";

export interface IToggleButtonTwoOptionsProps extends IBaseFormElementProps {
    optionOne?: string;
    optionTwo?: string;
    value?: boolean; // true for optionTwo false for optionOne
    onChange: (checked: boolean) => any;
    cssWrapperFirstOption?: string;
    cssWrapperSecondOption?: string;
    disabled?: boolean;
    label?: string;
    tooltip?: boolean;
}

export interface IToggleButtonTwoOptionsState {
    secondOptionChecked: boolean;
    disable?: boolean;
}

export class ToggleButtonTwoOptions extends BaseFormElement<
    IToggleButtonTwoOptionsProps,
    IToggleButtonTwoOptionsState
> {
    private _inputRef: HTMLInputElement;

    private _checkboxRef: HTMLInputElement;

    public isValid() {
        return true;
    }

    public setDisable() {
        this.setState({ disable: true });
    }

    constructor(props: IToggleButtonTwoOptionsProps) {
        super(props);
        this.state = this.getDefaultState();
    }

    private _guid: string = Guid.getNext();

    componentDidUpdate(prevProps) {
        if (this.props.value != prevProps.value) {
            this.setValue(this.props.value);
        }
    }
    

    public render(): JSX.Element {
        const { optionOne, optionTwo, disabled, label, tooltip, value } = this.props;
        const { secondOptionChecked, disable } = this.state;
        return (
            <fieldset className={classNames("radio-toggle", this.props.cssWrapperFirstOption)}>
                {label ? (
                    <div className="d-flex">
                        <legend className="mb-8">{label}</legend>
                        {tooltip && (
                            value ?
                            (<AriaTooltip cssWrapper="is-info-icon ml-6" title="More information on return basis">This is the percentage (%) measure to show how investments have performed over the set reporting period.  It's calculated by dividing the monetary change in value by the time and value of the transactions that took place over the period. This figure is non-annualised.</AriaTooltip>)
                            :
                            (<AriaTooltip cssWrapper="is-info-icon ml-6" title="More information on return basis">This is a non-weighted measure to show the change in value of the investment in percentage terms. The "Change in Value" is divided by the amount invested over the period - i.e. by the opening value plus any money added in the period.</AriaTooltip>)
                        )}
                    </div>
                ) : (
                    <legend className="sr-only">{`Pick ${optionOne} or ${optionTwo}`}</legend>
                )}
                <label className="radio-button">
                    <input
                        className="rb-input"
                        type="radio"
                        value={optionOne}
                        checked={!secondOptionChecked}
                        onChange={() => this.firstOptionClicked()}
                        disabled={disable ? disable : disabled}
                        name={optionOne + this._guid}
                    />
                    <span aria-hidden={true} className="rb-design"></span>
                    <span className="rb-label" title={optionOne}>
                        {optionOne}
                    </span>
                </label>
                <label className={classNames("radio-button", this.props.cssWrapperSecondOption)}>
                    <input
                        className="rb-input"
                        type="radio"
                        value={optionTwo}
                        checked={secondOptionChecked}
                        onChange={() => this.secondOptionClicked()}
                        disabled={disable ? disable : disabled}
                        name={optionTwo + this._guid}
                    />
                    <span aria-hidden={true} className="rb-design"></span>
                    <span className="rb-label pl-4" title={optionTwo}>
                        {optionTwo}
                    </span>
                </label>
            </fieldset>
        );
    }

    private getDefaultState(): IToggleButtonTwoOptionsState {
        return { secondOptionChecked: this.props.value };
    }

    private setValue(value: boolean): any {
        this.setState({
            secondOptionChecked: value,
        });
    }

    private firstOptionClicked(): void {
        if (this.state.secondOptionChecked) {
            this.toggleSwitchButton();
        }
    }

    private secondOptionClicked(): void {
        if (!this.state.secondOptionChecked) {
            this.toggleSwitchButton();
        }
    }

    private toggleSwitchButton(): void {
        const newValue = !this.state.secondOptionChecked;
        this.setValue(newValue);

        if (this.props.onChange) {
            this.props.onChange(newValue);
        }

        // this._checkboxRef.focus();
    }
}
